<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Drink the Tea</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"> </p>
<h2 class="h2a"><a id="page_1"></a><a id="part01"></a>PART ONE</h2>
<p class="image1"><img alt="Image" src="images/line.gif"/></p>
<p class="image"><img alt="Image" src="images/cup.gif"/></p>
<p class="center-para"><em>If anyone wishes to enter the Way of Tea,<br/>they must become their own teacher.</em><br/>—<span class="smallcaps">RIKYU</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?51509d50